import { Button } from "../Button";
import { VideoEmbed } from "../VideoEmbed";
import type { Audience } from "@/content/audiences";

export function AudienceHero({ audience: a }: { audience: Audience }) {
  return (
    <section className="pt-28 md:pt-40">
      <div className="container-wide">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:items-center lg:gap-12">
          <div className="order-2 max-w-2xl lg:order-1">
            <div className="mb-3 text-xs uppercase tracking-[0.18em] text-mint md:mb-4">
              För vem · {a.label}
            </div>
            <h1 className="text-balance text-[2rem] font-semibold leading-[1.08] sm:text-4xl md:text-7xl md:leading-[1.02]">
              {a.intro}
            </h1>
            <p className="mt-4 line-clamp-4 text-pretty text-base text-muted-foreground md:mt-8 md:line-clamp-none md:text-xl">
              {a.longIntro}
            </p>

            <div className="mt-5 flex items-start gap-3 rounded-2xl border border-mint/25 bg-mint/[0.06] px-4 py-3.5 md:mt-8 md:inline-flex md:px-5 md:py-4">
              <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-mint" />
              <span className="text-sm font-medium text-foreground/90 md:text-base">
                {a.metric}
              </span>
            </div>

            <div className="mt-6 grid gap-3 md:mt-10 md:flex md:flex-wrap">
              <Button
                to="/kontakt"
                variant="peach"
                arrow
                className="w-full justify-center md:w-auto"
                trackId="book_strategy_meeting"
                trackProps={{ location: `audience_${a.slug}_hero` }}
              >
                Boka 30 min – kostnadsfritt
              </Button>
              <Button
                to={a.recommendHref}
                variant="outline"
                arrow
                className="w-full justify-center md:w-auto"
                trackId="audience_recommend_package"
                trackProps={{ location: `audience_${a.slug}_hero`, audience_slug: a.slug, label: a.recommend }}
              >
                Vi rekommenderar: {a.recommend}
              </Button>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <AudienceHeroVideo videoId={a.heroVideoId} label={a.label} />
          </div>
        </div>
      </div>
    </section>

  );
}

function AudienceHeroVideo({ videoId, label }: { videoId: string; label: string }) {
  return (
    <div className="relative">
      <div className="absolute -inset-6 -z-10 rounded-[2.25rem] bg-gradient-to-br from-peach/15 via-transparent to-mint/15 blur-2xl" />
      <div className="overflow-hidden rounded-[2rem] border border-white/10 bg-black shadow-[0_30px_80px_-30px] shadow-black/60">
        <VideoEmbed
          id={videoId}
          title={`Fenny — exempelfilm för ${label}`}
          priority="high"
          className="rounded-none"
        />
      </div>
      <div className="pointer-events-none absolute left-4 top-4 rounded-full bg-black/60 px-3 py-1 text-[11px] uppercase tracking-widest text-white/85 backdrop-blur">
        Exempel · {label}
      </div>
    </div>
  );
}
